/* Palmiye Gurme — Mağaza Bulucu (sections/pg-store-locator.liquid)
   Vanilla JS, bağımlılıksız. Harita için Leaflet yalnızca harita görünür alana yaklaşınca yüklenir (API anahtarı gerekmez).
   Tüm kullanıcı metinleri bölüm ayarlarından gelir: <script type="application/json" data-store-i18n>. */
(() => {
  'use strict';

  const TZ = 'Europe/Istanbul';
  const LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  const LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  /* OpenStreetMap standart karoları: API anahtarı gerektirmez, atıf zorunludur (OSM kullanım politikası). */
  const TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
  const TILE_ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a>';
  const DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  /* Türkçe duyarlı sadeleştirme: "Ümraniye" = "umraniye", "İSTANBUL" = "istanbul" */
  const norm = (v) => String(v || '')
    .toLocaleLowerCase('tr-TR')
    .replace(/ı/g, 'i')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  const esc = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const fill = (tpl, vars) => String(tpl || '').replace(/\{(\w+)\}/g, (_, k) => (k in vars ? vars[k] : ''));

  let leafletPromise = null;
  function loadLeaflet() {
    if (window.L) return Promise.resolve(window.L);
    if (leafletPromise) return leafletPromise;
    leafletPromise = new Promise((resolve, reject) => {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = LEAFLET_CSS;
      document.head.appendChild(css);
      const js = document.createElement('script');
      js.src = LEAFLET_JS;
      js.async = true;
      js.onload = () => (window.L ? resolve(window.L) : reject(new Error('leaflet')));
      js.onerror = reject;
      document.head.appendChild(js);
    }).catch((err) => { leafletPromise = null; throw err; });
    return leafletPromise;
  }

  function nowInIstanbul() {
    const p = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
    const get = (t) => (p.find((x) => x.type === t) || {}).value;
    const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
    return { day, minutes: (parseInt(get('hour'), 10) % 24) * 60 + parseInt(get('minute'), 10) };
  }
  const toMin = (hhmm) => { const [h, m] = String(hhmm).split(':').map(Number); return h * 60 + (m || 0); };

  function haversineKm(a, b) {
    const R = 6371;
    const rad = (x) => (x * Math.PI) / 180;
    const dLat = rad(b.lat - a.lat);
    const dLng = rad(b.lng - a.lng);
    const s = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(s));
  }
  const kmFmt = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 1, minimumFractionDigits: 1 });

  function init(root) {
    if (root.dataset.pgStoreReady) return;
    root.dataset.pgStoreReady = '1';

    const $ = (sel, el = root) => el.querySelector(sel);
    const $$ = (sel, el = root) => Array.from(el.querySelectorAll(sel));
    let T = {};
    try { T = JSON.parse(($('[data-store-i18n]') || {}).textContent || '{}'); } catch (_) { T = {}; }

    const grid = $('[data-store-grid]');
    const input = $('[data-store-search]');
    const clearBtn = $('[data-store-clear]');
    const countEl = $('[data-store-count]');
    const emptyEl = $('[data-store-empty]');
    const notice = $('[data-store-notice]');
    const locateBtn = $('[data-store-locate]');
    const locateLabel = $('[data-store-locate-label]');
    const chips = $$('[data-store-filters] [data-city]');
    if (!grid) return;

    const stores = $$('[data-store]').map((el, index) => {
      const d = el.dataset;
      return {
        el,
        item: el.closest('.pg-store-grid__item'),
        index,
        name: d.name,
        city: d.city,
        district: d.district,
        address: d.address,
        mapsUrl: d.mapsUrl,
        lat: parseFloat(d.lat),
        lng: parseFloat(d.lng),
        hay: norm([d.name, d.city, d.district, d.address, d.keywords].join(' ')),
        distance: null,
        marker: null,
      };
    });
    const state = { q: '', city: '', user: null };

    /* ------------------------------------------------ çalışma saatleri
       metaobject "opening_hours" JSON: {"mon":["09:00","22:00"], ..., "sun":null} — null = kapalı.
       Veri yoksa Liquid'in bastığı "arayın" metni kalır; saat uydurulmaz. */
    function renderHours(store) {
      const raw = store.el.dataset.hours;
      if (!raw) return;
      let hours;
      try { hours = JSON.parse(raw); } catch (_) { return; }
      if (!hours || typeof hours !== 'object') return;
      const { day, minutes } = nowInIstanbul();
      const today = hours[DAY_KEYS[day]];
      const textEl = $('[data-hours-text]', store.el);
      if (!textEl) return;
      const valid = Array.isArray(today) && today.length === 2;
      const open = valid && minutes >= toMin(today[0]) && minutes < toMin(today[1]);
      const badge = `<span class="pg-store-status ${open ? 'pg-store-status--open' : 'pg-store-status--closed'}">${esc(open ? T.open : T.closed)}</span>`;
      const line = valid ? esc(fill(T.today_hours, { from: today[0], to: today[1] })) : esc(T.today_closed);
      textEl.innerHTML = badge + line;
    }

    /* ------------------------------------------------ filtreleme */
    function apply() {
      const words = norm(state.q).split(' ').filter(Boolean);
      let visible = 0;
      const ordered = stores.slice();
      if (state.user) ordered.sort((a, b) => (a.distance ?? Infinity) - (b.distance ?? Infinity));
      else ordered.sort((a, b) => a.index - b.index);

      ordered.forEach((s) => {
        const show = (!state.city || s.city === state.city) && words.every((w) => s.hay.includes(w));
        s.item.hidden = !show;
        grid.appendChild(s.item);
        if (show) visible++;
        if (s.marker) {
          const el = s.marker.getElement();
          if (el) el.style.display = show ? '' : 'none';
        }
      });

      if (countEl) {
        countEl.innerHTML = fill(esc(T.count), { count: `<strong>${visible}</strong>` }) + (state.user ? esc(T.count_sorted || '') : '');
      }
      if (emptyEl) emptyEl.hidden = visible > 0;
      grid.hidden = visible === 0;
      if (clearBtn) clearBtn.hidden = !state.q;
      chips.forEach((c) => c.setAttribute('aria-pressed', String((c.dataset.city || '') === state.city)));
      fitMapToVisible();
    }

    if (input) {
      let t = 0;
      input.addEventListener('input', () => {
        clearTimeout(t);
        t = setTimeout(() => { state.q = input.value; apply(); }, 120);
      });
    }
    const form = $('[data-store-form]');
    if (form) form.addEventListener('submit', (e) => { e.preventDefault(); if (input) state.q = input.value; apply(); });
    if (clearBtn) clearBtn.addEventListener('click', () => { input.value = ''; state.q = ''; apply(); input.focus(); });
    chips.forEach((chip) => chip.addEventListener('click', () => { state.city = chip.dataset.city || ''; apply(); }));
    const resetBtn = $('[data-store-reset]');
    if (resetBtn) resetBtn.addEventListener('click', () => {
      if (input) input.value = '';
      state.q = ''; state.city = ''; apply();
      if (input) input.focus();
    });

    /* ------------------------------------------------ konum */
    function setNotice(text, ok) {
      if (!notice) return;
      notice.textContent = text || '';
      notice.classList.toggle('pg-store-notice--ok', !!ok);
    }
    if (locateBtn) locateBtn.addEventListener('click', () => {
      if (!('geolocation' in navigator)) { setNotice(T.locate_error); return; }
      locateBtn.setAttribute('aria-busy', 'true');
      locateLabel.textContent = T.locate_busy;
      setNotice('');
      navigator.geolocation.getCurrentPosition((pos) => {
        state.user = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        stores.forEach((s) => {
          if (!Number.isFinite(s.lat) || !Number.isFinite(s.lng)) return;
          s.distance = haversineKm(state.user, s);
          const badge = $('[data-distance]', s.el);
          if (badge) { badge.textContent = `${kmFmt.format(s.distance)} km`; badge.hidden = false; }
        });
        locateBtn.removeAttribute('aria-busy');
        locateBtn.classList.add('is-active');
        locateLabel.textContent = T.locate_active;
        const nearest = stores.filter((s) => s.distance != null).sort((a, b) => a.distance - b.distance)[0];
        if (nearest) setNotice(fill(T.locate_nearest, { name: nearest.name, km: kmFmt.format(nearest.distance) }), true);
        apply();
        showUserOnMap();
      }, () => {
        locateBtn.removeAttribute('aria-busy');
        locateLabel.textContent = T.locate_label;
        setNotice(T.locate_error);
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
    });

    /* ------------------------------------------------ harita */
    const mapBox = $('[data-store-map]');
    const mapCanvas = $('[data-store-map-canvas]');
    const mapFallback = $('[data-store-map-fallback]');
    let map = null;
    let userMarker = null;

    function popupHtml(s) {
      return `<p class="pg-store-pop__meta">${esc(s.city)} · ${esc(s.district)}</p>
        <p class="pg-store-pop__title">${esc(s.name)}</p>
        <p class="pg-store-pop__addr">${esc(s.address)}</p>
        <a class="pg-store-pop__link" href="${esc(s.mapsUrl)}" target="_blank" rel="noopener noreferrer">${esc(T.directions)}</a>`;
    }

    function initMap() {
      if (!mapBox) return Promise.resolve(null);
      return loadLeaflet().then((L) => {
        if (map) return map;
        map = L.map(mapCanvas, { scrollWheelZoom: false, zoomControl: true, attributionControl: true });
        L.tileLayer(TILE_URL, { attribution: TILE_ATTR, maxZoom: 19, className: 'pg-store-tiles' }).addTo(map);
        const icon = L.divIcon({ className: '', html: '<div class="pg-store-pin"></div>', iconSize: [30, 30], iconAnchor: [15, 30], popupAnchor: [0, -28] });
        stores.forEach((s) => {
          if (!Number.isFinite(s.lat) || !Number.isFinite(s.lng)) return;
          s.marker = L.marker([s.lat, s.lng], { icon, title: s.name, keyboard: true, alt: s.name }).addTo(map).bindPopup(popupHtml(s), { maxWidth: 240, autoPanPadding: [56, 16] });
          s.marker.on('click', () => highlight(s));
        });
        mapBox.classList.add('is-ready');
        if (state.user) showUserOnMap();
        apply();
        return map;
      }).catch(() => {
        if (mapFallback) mapFallback.innerHTML = `<strong>${esc(T.map_error_title)}</strong><span>${esc(T.map_error_text)}</span>`;
        return null;
      });
    }

    function fitMapToVisible() {
      if (!map || !window.L) return;
      const pts = stores.filter((s) => !s.item.hidden && s.marker).map((s) => [s.lat, s.lng]);
      if (state.user) pts.push([state.user.lat, state.user.lng]);
      if (!pts.length) return;
      if (pts.length === 1) map.setView(pts[0], 15);
      else map.fitBounds(pts, { padding: [36, 36], maxZoom: 15 });
    }

    function showUserOnMap() {
      if (!map || !state.user || !window.L) return;
      const L = window.L;
      const icon = L.divIcon({ className: '', html: '<div class="pg-store-user-dot"></div>', iconSize: [16, 16], iconAnchor: [8, 8] });
      if (userMarker) userMarker.setLatLng([state.user.lat, state.user.lng]);
      else userMarker = L.marker([state.user.lat, state.user.lng], { icon, title: T.your_location, keyboard: false }).addTo(map);
      fitMapToVisible();
    }

    function highlight(s) {
      stores.forEach((x) => {
        x.el.classList.toggle('is-highlight', x === s);
        const pin = x.marker && x.marker.getElement() && x.marker.getElement().querySelector('.pg-store-pin');
        if (pin) pin.classList.toggle('is-active', x === s);
      });
    }

    $$('[data-show-on-map]').forEach((btn) => btn.addEventListener('click', () => {
      const s = stores.find((x) => x.el.contains(btn));
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!mapBox) return;
      mapBox.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      initMap().then(() => {
        if (!map || !s || !s.marker) return;
        map.setView([s.lat, s.lng], 16, { animate: !reduce });
        s.marker.openPopup();
        highlight(s);
      });
    }));

    if (mapBox) {
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { io.disconnect(); initMap(); }
        }, { rootMargin: '200px' });
        io.observe(mapBox);
      } else {
        initMap();
      }
    }

    /* ------------------------------------------------ SSS */
    $$('[data-store-faq] .pg-store-faq__btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = open;
      });
    });

    stores.forEach(renderHours);
    apply();
  }

  const boot = (scope) => (scope || document).querySelectorAll('[data-pg-store-locator]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  /* Tema düzenleyicisinde bölüm yeniden yüklendiğinde */
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
